import { styled } from 'styled-components';

import { IconButton, Typography } from '@mui/material';

export const FooterContainer = styled.footer`
  background-color: var(--mui-palette-backgroud-paper);
  .info {
    > div {
      padding: 20px 15px 0px 15px;
    }
  }
`;

export const CopyrightLabel = styled(Typography)`
  font-weight: 600;
  font-family: 'Roboto', sans-serif;
  font-size: 13px;
  line-height: 150%;
  padding-bottom: 20px;
`;

export const ContainerInfo = styled.div`
  padding: 50px 0;
  display: flex;
  align-items: center;
  max-width: 1096px;
  margin: auto;
`;

export const TypographyInfo = styled(Typography)`
  font-family: 'Montserrat', sans-serif;
  font-size: 12px;
  .MuiSvgIcon-root {
    margin-right: 5px;
    margin-top: 2px;
    font-size: 20px;
    vertical-align: text-bottom;
  }
`;

export const WrapperInfo = styled.div`
  align-self: flex-start;
  flex: 1;
`;

export const SocialIconButton = styled(IconButton)`
  display: inline-flex;
  background-color: var(--mui-palette-secondary-main);
  color: white;
  border-radius: 50%;
  width: 34px;
  height: 34px;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
  z-index: -1;
  &:hover {
    background-color: var(--mui-palette-primary-main);
  }
`;

export const WrapperLogo = styled.div`
  flex: 1;
`;

export const WrapperSocial = styled.div`
  padding-left: 25px;
  flex: 1;
`;

export const Logo = styled.img`
  height: 50px;
  margin: auto 0;
`;
